export default "/assets/images/performance-filter-img-01.webp?c0970d383c8197d1f53470a21c1718f7";